import LeaseAmendment from './LeaseAmendment';
import Acknowledgement from '../leasing/Acknowledgement';
import Leasehold from './Leasehold';
// import LeaseholdClauses from './LeaseholdClauses';
import ContractAddendumClauseXRef from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractAddendumClauseXRef';
import ContractAdHocClause from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractAdHocClause';
import ContractGenerationTractDetail from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractGenerationTractDetail';
import IContract from '../contract_types/IContract';

export default class Lease implements IContract {
    id: number;
    volume: string;
    page: string;
    recordedDate?: Date;
    leaseDate: Date;
    effectiveDate: Date;
    originalLessor: string;
    originalLessee: string;
    fedStateLeaseNumber: string;
    isFiledByMemo?: boolean;
    recordTypeId: number;
    instrumentNumber: string;
    isRentalLease: boolean;
    rentalPrice: number;
    rentalPriceTypeId: number;
    originalGross: number;
    leaseNumber: string;
    leasehold?: Leasehold;

    adHocClauses?: Array<ContractAdHocClause>;
    removeClauses?: Array<number>;
    contractClauses?: Array<ContractAddendumClauseXRef>;
    leaseAmendments?: Array<LeaseAmendment>;

    isCommitted?: boolean;
    committedDate?: Date;
    isInHand?: boolean;
    inHandDate?: Date;
    isTransfer?: boolean;
    transferDate?: Date;
    clientDocNumber: string;
    leasedBy: string;
    reminderDate?: Date;
    reminderNote: string;
    rentalDueDate?: Date;
    rentalAmount?: number;
    rentalPaymentUnit?: string;
    rentalTotalRent?: number;
    rentalBankName?: string;
    rentalAddress?: string;
    rentalCity?: string;
    rentalState?: string;
    rentalZipCode?: string;
    isTopLease?: boolean;
    topLeasePercentDown?: number;
    topLeaseAmount?: number;
    topLeaseRemainingBalance?: number;
    topLeaseDraftType?: string;
    topLeaseDraftDays?: number;
    topLeaseBalanceReminder?: string;
    topLeaseNote?: string;
    topLeaseRecordedType?: string;
    topLeaseBook?: string;
    topLeasePage?: string;
    topLeaseActiveDate?: Date;
    topLeaseExpirationDate?: Date;
    ownersOnDocument: string;
    ownersAddressOnDocument: string;
    ownersSSNTaxIdOnDocument: string;
    clientFacingNotes?: string;
    legalDescription: string;
    primaryTerm?: number;
    primaryTermUnits?: string;
    bonusAmount?: number;
    bonusUnits?: string;
    totalBonus?: number;
    isOptionToExtend?: boolean;
    optionBonusAmount?: number;
    optionBonusUnits?: string;
    optionTotalBonus?: number;
    optionTerm?: number;
    optionTermUnits?: string;
    isAddOptionToExtend?: boolean;
    addOptionBonusAmount?: number;
    addOptionBonusUnits?: string;
    addOptionTotalBonus?: number;
    addOptionTerm?: number;
    addOptionTermUnits?: string;
    addConsiderationAmount?: number;
    addConsiderationExplanation?: string;
    totalConsideration?: number;
    lesseeName: string;
    lesseeAddressLine1: string;
    lesseeAddressLine2: string;
    lesseeCity: string;
    lesseeState: string;
    lesseeZipCode: string;
    lesseePhoneNumber: string;
    lesseeSignature: string;
    lesseeAcknowledgement: string;
    lesseeSignatureType: string;
    lesseeOwnerLookupId?: number;
    isNotOriginalLessee: boolean;
    originalLesseeName?: string;
    isGeneratedLease?: boolean;
    createdDate: Date;
    isVoid?: boolean;
    leaseLessorNotes: string;
    invoiceableLookupId?: number;
    ownerId?: number;
    rteLegalDescription: string;
    shortLegalDescription?: string;
    bankingDays?: number;
    bankingDaysUnit?: string;
    originalInHandDate?: Date;

    isAddConsideration?: boolean;

    tracts?: Array<ContractGenerationTractDetail>;
    acknowledgements?: Array<Acknowledgement>;

    leaseholds?: Array<Leasehold>;
    leaseHoldIds?: Array<number>;
}



// WEBPACK FOOTER //
// ./src/models/leasehold/Lease.ts